export default __webpack_public_path__ + "static/media/xtreme-project-2.86ee1218.jpg";